import { anchorate } from "anchorate"

export const onRouteUpdate = () => {
  // Scroll to anchor tags when in JS-mode
  anchorate()
}
